import { render } from "./category-levels-assessment-desktop.vue?vue&type=template&id=712bda0e&ts=true"
import script from "./category-levels-assessment-desktop.vue?vue&type=script&lang=ts"
export * from "./category-levels-assessment-desktop.vue?vue&type=script&lang=ts"

import "./category-levels-assessment-desktop.vue?vue&type=style&index=0&id=712bda0e&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__